import { TextInput, required } from "react-admin";
import { Grid } from "@mui/material";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={6}
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextInput
          label="Кратко име на български език"
          source="nameBgShort"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
      >
        <TextInput
          label="Име на анлийски"
          source="nameEn"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextInput
          label="Кратко име на анлийски"
          source="nameEnShort"
          validate={required()}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
